import React from 'react';
import { MdDesktopMac, MdCode, MdPhonelinkSetup } from 'react-icons/md';
import styled from 'styled-components';
import SectionTitle from './SectionTitle';
import ServicesSectionItem from './ServicesSectionItem';

const ServicesItemsStyles = styled.div`
  padding: 10rem 0;
  .services__allItems {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1.8rem;
    margin-top: 5rem;
  }
  @media only screen and (max-width: 768px) {
    .services__allItems {
      grid-template-columns: 1fr;
      max-width: 520px;
      margin: 0 auto;
      margin-top: 5rem;
      gap: 1.4rem;
    }
  }
`;

export default function ServicesSection() {
  return (
    <ServicesItemsStyles>
      <div className="container">
        <SectionTitle subheading="What i will do for you" heading="Services" />
        <div className="services__allItems">
          <ServicesSectionItem
            icon={<MdDesktopMac />}
            title="Product Engineering"
            desc="Thoughtful React and TypeScript interfaces that make complex products clear, fast, and easy to use."
          />
          <ServicesSectionItem
            icon={<MdCode />}
            title="APIs & Backend Systems"
            desc="Production-ready Node.js, Express, FastAPI, SQL, authentication, integrations, and background processing."
          />
          <ServicesSectionItem
            icon={<MdPhonelinkSetup />}
            title="Cloud & Mobile Delivery"
            desc="Azure deployments, Nginx and PM2 hosting, plus React Native apps with API integration for Android and iOS."
          />
        </div>
      </div>
    </ServicesItemsStyles>
  );
}
